

export function matchesMentionQuery(query, keys) {
  const q = query.trim().toLowerCase()
  if (!q) return true
  return [...keys].some((k) => k.startsWith(q) || k.includes(q))
}
